import { gql } from '@apollo/client';

export enum ContactCircle {
    CLOSE = 0,
    INTERMEDIATE = 1,
    FAR = 2,
}

export enum ContactKind {
    PERSONAL = 'personal',
    PROFESSIONAL = 'professional',
}

export interface UnifiedContact {
    id: string;

    primaryEmail: string;
    visible?: boolean;

    birthday?: string;
    displayName?: string;
    effectiveName?: string;
    familyName?: string;
    givenName?: string;
    honorificPrefix?: string;
    honorificSuffix?: string;
    ignoreBirthday?: boolean;
    middleName?: string;

    photoImageUrl?: string;
    emailHash?: string;

    effectiveBriefKey?: string;
    brief?: any; // TODO: Brief type!

    effectiveKind?: ContactKind[];

    chosenCircle?: ContactCircle;
    effectiveCircle?: ContactCircle;
    proposedCircle?: ContactCircle;

    chosenHuman?: boolean;
    effectiveHuman?: boolean;
    proposedHuman?: boolean;

    userSetAuthoritativeForBirthday?: boolean;
    userSetAuthoritativeForName?: boolean;
    userSetAuthoritativeForPhoto?: boolean;
    userSetAuthoritativeForPrimaryEmail?: boolean;

    createdAt?: string;
    updatedAt?: string;

    mappings?: any; // TODO: Mapping type!
    allMappings?: any; // TODO: Mapping type!
    potentialMappings?: any; // TODO: Mapping type!
}

export const FETCH_UNIFIED_CONTACTS = gql`
query fetchContacts($visible: Boolean, $human: Boolean, $circle: [Int!], $sortColumn: UnifiedContactColumnsEnum, $sortDirection: SortDirectionEnum, $keyword: String) {
    user {
        unifiedContacts(visible: $visible, human: $human, circle: $circle, sortColumn: $sortColumn, sortDirection: $sortDirection, keyword: $keyword) {
            id

            primaryEmail
            visible

            birthday
            displayName
            effectiveName
            familyName
            givenName
            honorificPrefix
            honorificSuffix
            ignoreBirthday
            middleName

            photoImageUrl
            emailHash

            chosenCircle
            effectiveCircle
            proposedCircle

            chosenHuman
            effectiveHuman
            proposedHuman

            userSetAuthoritativeForBirthday
            userSetAuthoritativeForName
            userSetAuthoritativeForPhoto
            userSetAuthoritativeForPrimaryEmail

            createdAt
            updatedAt

            mappings {
                contact {
                    account {
                        id

                        name

                        kind
                    }
                    recentMessagesReceivedCount
                    recentMessagesSentCount
                    recentMeetingsCount
                }
            }
        }
    }
}
`;

export const FETCH_UNIFIED_CONTACTS_FOR_INVITES = gql`
query fetchContacts($visible: Boolean, $human: Boolean, $invitable: Boolean, $sortColumn: UnifiedContactColumnsEnum, $sortDirection: SortDirectionEnum) {
    user {
        unifiedContacts(visible: $visible, human: $human, invitable: $invitable, sortColumn: $sortColumn, sortDirection: $sortDirection) {
            id

            primaryEmail
            visible

            displayName

            photoImageUrl
            emailHash

            effectiveCircle
        }
    }
}
`;
